import { MutationResult } from "@/api/utils/types"
import { useMutation } from "@/api/utils/useQuery"
import Cache from "@/api/utils/Cache"
import { BackofficeRestMutations } from "@/api/backofficeRest/mutations"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import { AuthService } from "@/services/AuthService"
import {
  IRemoveFromInvoluntaryPayg,
  IRemoveFromInvoluntaryPaygSerialized,
  IMeterExchangeJourneyAction,
} from "./WarrantsMutator.types"

export interface IWarrantsMutator {
  removeFromInvoluntaryPayg(): MutationResult<IRemoveFromInvoluntaryPayg>
  addToMeterExchangeJourney(): MutationResult<IMeterExchangeJourneyAction>
  removeFromMeterExchangeJourney(): MutationResult<IMeterExchangeJourneyAction>
}

class WarrantsMutatorClass implements IWarrantsMutator {
  removeFromInvoluntaryPayg() {
    return useMutation({
      ...BackofficeRestMutations.warrants.deleteByAccountNumber(),
      serializerFn: (
        data: IRemoveFromInvoluntaryPayg,
      ): IRemoveFromInvoluntaryPaygSerialized => ({
        accountNumber: data.accountNumber,
        agentEmail: AuthService.getCurrentUser().username,
      }),
      onSuccessFn: () => {
        Cache.invalidate([...BackofficeRestQueries.warrants.status._def])
      },
    })
  }

  addToMeterExchangeJourney() {
    return this.meterExchangeJourneyMutation(
      BackofficeRestMutations.warrants.addToMeterExchange(),
    )
  }

  removeFromMeterExchangeJourney() {
    return this.meterExchangeJourneyMutation(
      BackofficeRestMutations.warrants.removeFromMeterExchange(),
    )
  }

  private meterExchangeJourneyMutation(mutation: {
    mutationFn: (variables: {
      billingAccountId: number
      body: { agentEmail: string }
    }) => Promise<void>
  }) {
    return useMutation({
      ...mutation,
      serializerFn: (data: IMeterExchangeJourneyAction) => ({
        billingAccountId: data.billingAccountId,
        body: buildMeterExchangeAgentBody(),
      }),
      onSuccessFn: invalidateMeterExchangeEligibility,
    })
  }
}

const buildMeterExchangeAgentBody = () => ({
  agentEmail: AuthService.getCurrentUser().username,
})

const invalidateMeterExchangeEligibility = () => {
  Cache.invalidate([
    ...BackofficeRestQueries.warrants.meterExchangeEligibility._def,
  ])
}

export const WarrantsMutator = new WarrantsMutatorClass()
